import React, { useState } from 'react';
import ReactTable from 'react-table'
import numeral from "numeral";
import moment from "moment";

const AdminTransactionTable = props => {
    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 75,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'ORDER ID',
        accessor: 'order_id',
        maxWidth: 200
    },{
        Header: 'WAYBILL ID',
        maxWidth: 120,
        accessor: 'waybill_id'
    },{
        Header: 'PENGIRIM',
        maxWidth: 120,
        accessor: 'origin_name'
    },{
        Header: 'PENERIMA',
        maxWidth: 200,
        accessor: 'destination_name'
    },{
        Header: 'KURIR',
        maxWidth: 200,
        accessor: 'courier_company'
    },{
        Header: 'LAYANAN',
        maxWidth: 200,
        accessor: 'courier_service'
    },{
        Header: 'BASIC COST ',
        maxWidth: 200,
        accessor: 'price',
        Cell: ({row, original}) => `Rp. ${numeral(original.basic_price).format("0,0")}`
    },{
        Header: 'DISKON',
        maxWidth: 200,
        accessor: 'discount_price',
        Cell: ({row, original}) => `${original.discount_percentage}% - Rp. ${numeral(original.basic_price*original.discount_percentage/100).format("0,0")}`
    },{
        Header: 'HARGA',
        maxWidth: 200,
        accessor: 'price',
        Cell: ({row, original}) => `Rp. ${numeral(original.price).format("0,0")}`
    },{
        Header: 'WAKTU PENGIRIMAN',
        accessor: 'delivery_time',
        maxWidth: 200,
        Cell: ({row, original}) => moment(row.delivery_time).format("YYYY-MM-DD HH:mm")
    }];

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={50}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminTransactionTable;
